import React from 'react';
import { MissionContext } from '../../providers';
export const ParticipantDetails = () => {
    const { participantDetailsComponent: ParticipantDetailsComponent, onParticipantReset, slideoutMenuItems, participantId, } = React.useContext(MissionContext);
    return (React.createElement(React.Fragment, null, ParticipantDetailsComponent && (React.createElement(ParticipantDetailsComponent, { onParticipantIdReset: onParticipantReset, slideoutMenuItems: slideoutMenuItems, participantId: participantId }))));
};
